import { clickToDialPhoneNumberRegExp } from './regexp.mjs';

// Currently we're receiving 2 different 'displayNames' for click2dial calls.
// One of them is 'Calling...' where the other one is 'calling:{number}'.
// In the future the 'Calling...' mode will be disabled.
export default function isClickToDial(displayName = '') {
  return displayName === 'Calling...' || displayName.match(clickToDialPhoneNumberRegExp) !== null;
}
